"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _kebabCase2 = _interopRequireDefault(require("lodash/kebabCase"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _hideVisually = _interopRequireDefault(require("../../../../theme/shared/hideVisually"));
var _Text = _interopRequireDefault(require("../../Text/Text"));
const RevealTextWidth = 55;
const RevealTextSpeed = 0.35;
const StyledLink = _styledComponents.default.a.withConfig({
  displayName: "Icon__StyledLink",
  componentId: "sc-no6fx6-0"
})(["text-decoration:none;cursor:pointer;display:block;position:relative;transition:opacity 0.2s;&:hover,&:focus{opacity:0.6;}", "};"], _ref => {
  let {
    isHeader
  } = _ref;
  return isHeader && (0, _styledComponents.css)(["overflow:hidden;padding-right:0px;transition:padding-right ", "s cubic-bezier(0.5,1.5,0.5,0.75);&:hover,&:focus{opacity:1;}@media ", "{&:hover,&:focus{img{filter:invert(0.5) sepia(1) saturate(100) hue-rotate(20deg);}}}@media ", "{&:hover,&:focus{padding-right:", "px;&[data-test=\"header-esu\"]{padding-right:92px;}&[data-test=\"header-shop\"]{padding-right:48px;}img + span{display:block;}}"], RevealTextSpeed, _ref2 => {
    let {
      theme
    } = _ref2;
    return theme.allBreakpoints('M');
  }, _ref3 => {
    let {
      theme
    } = _ref3;
    return theme.allBreakpoints('NavWide');
  }, RevealTextWidth);
});
const RevealText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "Icon__RevealText",
  componentId: "sc-no6fx6-1"
})(["width:auto;color:", ";position:absolute;top:50%;transform:translateY(-50%);left:70px;@media ", "{width:100%;text-align:center;position:absolute;top:8px;left:15px;transform:translateX(0);display:none;color:", ";}"], _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.color('black');
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.allBreakpoints('Nav');
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.color('red');
});
const StyledImage = _styledComponents.default.img.withConfig({
  displayName: "Icon__StyledImage",
  componentId: "sc-no6fx6-2"
})(["width:100%;"]);
const HelperText = _styledComponents.default.span.withConfig({
  displayName: "Icon__HelperText",
  componentId: "sc-no6fx6-3"
})(["", ";"], _hideVisually.default);
const Icon = _ref7 => {
  let {
    href,
    target,
    icon,
    brand,
    title,
    isHeader = false,
    id,
    ...restProps
  } = _ref7;
  return /*#__PURE__*/_react.default.createElement(StyledLink, Object.assign({
    href: href,
    target: `_${target}`
  }, restProps, {
    title: title,
    rel: "noopener noreferrer",
    "data-test": `${isHeader ? 'header' : 'icon'}-${(0, _kebabCase2.default)(id)}`,
    isHeader: isHeader
  }), /*#__PURE__*/_react.default.createElement(StyledImage, {
    src: icon,
    alt: brand
  }), isHeader && /*#__PURE__*/_react.default.createElement(RevealText, null, title), id === 'esu' && /*#__PURE__*/_react.default.createElement(HelperText, null, "(opens in new window)"));
};
var _default = exports.default = Icon;